var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 8C26.2533 8 22 12.2533 22 17.5C22 22.7467 26.2533 27 31.5 27C36.7467 27 41 22.7467 41 17.5C41 12.2533 36.7467 8 31.5 8ZM25 17.5C25 13.9101 27.9101 11 31.5 11C35.0899 11 38 13.9101 38 17.5C38 21.0899 35.0899 24 31.5 24C27.9101 24 25 21.0899 25 17.5Z",
    fill: "#3DE8CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6683 32H10.15C6.75345 32 4 34.7534 4 38.15V43.5C4 44.3284 4.67157 45 5.5 45H14V50.5C14 52.433 15.567 54 17.5 54H45.5C47.433 54 49 52.433 49 50.5V45H57.5001C58.3285 45 59.0001 44.3284 59.0001 43.5V38.15C59.0001 34.7534 56.2466 32 52.8501 32H45.3317C43.722 30.7466 41.6982 30 39.5 30H23.5C21.3018 30 19.278 30.7466 17.6683 32ZM15.1313 35C14.4096 36.3394 14 37.8719 14 39.5V42H7V38.15C7 36.4103 8.4103 35 10.15 35H15.1313ZM47.8687 35C48.5904 36.3394 49 37.8719 49 39.5V42H56.0001V38.15C56.0001 36.4103 54.5898 35 52.8501 35H47.8687ZM28.0945 43.7711L29.7516 33H23.5C19.9101 33 17 35.9101 17 39.5V50.5C17 50.7761 17.2239 51 17.5 51H45.5C45.7761 51 46 50.7761 46 50.5V39.5C46 35.9101 43.0899 33 39.5 33H33.2484L34.9055 43.7711C35.0266 44.5582 34.7655 45.3559 34.2023 45.919L32.5607 47.5607C31.9749 48.1464 31.0251 48.1464 30.4393 47.5607L28.7977 45.919C28.2345 45.3559 27.9734 44.5582 28.0945 43.7711Z",
    fill: "#3DE8CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9996 24.5C42.9996 21.4624 45.462 19 48.4996 19C51.5372 19 53.9996 21.4624 53.9996 24.5C53.9996 27.5376 51.5372 30 48.4996 30C45.462 30 42.9996 27.5376 42.9996 24.5ZM48.4996 22C47.1189 22 45.9996 23.1193 45.9996 24.5C45.9996 25.8807 47.1189 27 48.4996 27C49.8803 27 50.9996 25.8807 50.9996 24.5C50.9996 23.1193 49.8803 22 48.4996 22Z",
    fill: "#3DE8CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99951 24.5C8.99951 21.4624 11.4619 19 14.4995 19C17.5371 19 19.9995 21.4624 19.9995 24.5C19.9995 27.5376 17.5371 30 14.4995 30C11.4619 30 8.99951 27.5376 8.99951 24.5ZM14.4995 22C13.1188 22 11.9995 23.1193 11.9995 24.5C11.9995 25.8807 13.1188 27 14.4995 27C15.8802 27 16.9995 25.8807 16.9995 24.5C16.9995 23.1193 15.8802 22 14.4995 22Z",
    fill: "#3DE8CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.9451d385bcf3919a9df7e020821923bd.svg";
export { ForwardRef as ReactComponent };